var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-personal-data"},[_vm._v(" Продолжая находиться на сайте, вы соглашаетесь с "),_c('a',{attrs:{"href":_vm.urls.policies.personalData}},[_vm._v("Политикой обработки персональных данных")])])
}
var staticRenderFns = []

export { render, staticRenderFns }